export default __webpack_public_path__ + "static/media/borrowing.94f0eafe.png";